import React from "react";

export default function MainLayout({ orderId, children }) {
  return (
    <>
      <header>
        <div className="container">
          <div className="header_part_1">
            <img src="/Logo.png"/>
          </div>
          <div className="header_part_2">
            <h2>Order Id :- #{orderId}</h2>
          </div>
        </div>
      </header>
      {children}
    </>
  );
}
